(function () {
  if (window.__cartClearOnBackNavigationInstalled) return;
  window.__cartClearOnBackNavigationInstalled = true;

  var BUNDLE_FLAG_KEY = 'larineBundleCheckoutRedirect';
  var SECTION_IDS = 'cart-drawer,cart-icon-bubble';
  var MAX_PASSES = 4;
  var RETRY_DELAYS_MS = [0, 300, 900, 2000];

  function isWebKit() {
    var ua = navigator.userAgent || '';
    return (/Safari/i.test(ua) && !/Chrome|Chromium|Android|Edg|OPR|Firefox/i.test(ua)) ||
      /iPhone|iPad|iPod/i.test(ua);
  }

  function flagCookieAttrs(clear) {
    var cookie = BUNDLE_FLAG_KEY + '=' + (clear ? '' : '1') + '; path=/; SameSite=Lax';
    cookie += clear ? '; max-age=0' : '; max-age=3600';
    if (location.protocol === 'https:') cookie += '; Secure';
    return cookie;
  }

  function cookieHasFlag() {
    try {
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].trim() === BUNDLE_FLAG_KEY + '=1') return true;
      }
    } catch (e) {}
    return false;
  }

  function liveFetch(url, opts) {
    var fn = window.__originalFetch || window.fetch;
    opts = opts || {};
    if (!opts.credentials) opts.credentials = 'same-origin';
    if (!opts.cache) opts.cache = 'no-store';
    // Safari/WebKit: keepalive + body often never settles after bfcache restore.
    if (isWebKit() && 'keepalive' in opts) opts.keepalive = false;
    return fn.call(window, url, opts);
  }

  function cartRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.slice(-1) === '/' ? r : r + '/';
  }

  function hasBundleFlag() {
    try {
      if (sessionStorage.getItem(BUNDLE_FLAG_KEY) === '1') return true;
    } catch (e) {}
    try {
      if (localStorage.getItem(BUNDLE_FLAG_KEY) === '1') return true;
    } catch (e2) {}
    return cookieHasFlag();
  }

  function clearBundleFlag() {
    try {
      sessionStorage.removeItem(BUNDLE_FLAG_KEY);
    } catch (e) {}
    try {
      localStorage.removeItem(BUNDLE_FLAG_KEY);
    } catch (e2) {}
    try {
      document.cookie = flagCookieAttrs(true);
    } catch (e3) {}
  }

  function isBackForwardNavigation() {
    if (window.performance && typeof performance.getEntriesByType === 'function') {
      var entries = performance.getEntriesByType('navigation');
      if (entries && entries[0]) return entries[0].type === 'back_forward';
    }
    return !!(window.performance && performance.navigation && performance.navigation.type === 2);
  }

  function isGumClearPage() {
    if (typeof window.__larineIsGumIgHideChrome === 'function') {
      return window.__larineIsGumIgHideChrome();
    }
    return window.__larineClearCartOnBackPage === true &&
      !!(document.body && document.body.hasAttribute('data-ig-hide-chrome'));
  }

  function whenGumIgHideChrome(cb) {
    if (typeof window.__larineWhenGumIgHideChrome === 'function') {
      window.__larineWhenGumIgHideChrome(cb);
      return;
    }
    if (isGumClearPage()) cb();
  }

  // Gum PDP + Intelligems hide-chrome variant only.
  function shouldClearNow() {
    if (!isGumClearPage()) return false;
    if (hasBundleFlag()) return true;
    if (isBackForwardNavigation()) return true;
    return false;
  }

  function beginClearLock() {
    window.__cartClearingOnBack = true;
    window.__cartDrawerUpdating = true;
    window.__cartBfcacheRestoring = true;
    document.documentElement.classList.add('cart-clearing-on-back');
  }

  function endClearLock() {
    window.__cartClearingOnBack = false;
    window.__cartDrawerUpdating = false;
    window.__cartBfcacheRestoring = false;
    document.documentElement.classList.remove('cart-clearing-on-back');
  }

  function paintEmptyCartUi() {
    if (window.cartDrawerCustom && typeof window.cartDrawerCustom.paintEmpty === 'function') {
      window.cartDrawerCustom.paintEmpty();
      return;
    }
    document.documentElement.classList.add('cart-clearing-on-back');
    var bubbles = document.querySelectorAll('.cart-count-bubble');
    for (var i = 0; i < bubbles.length; i++) bubbles[i].remove();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.add('is-empty');
      drawer.classList.remove('active');
    }
    var contents = document.getElementById('CartDrawer-CartItems');
    if (contents) contents.innerHTML = '';
  }

  function sectionPayload() {
    var list = ['cart-drawer', 'cart-icon-bubble'];
    if (document.getElementById('main-cart-items')) {
      list.push('cart-items', 'cart-footer');
    }
    return list;
  }

  function sectionsLookEmpty(sections) {
    var html = sections && sections['cart-drawer'];
    return !!(html && html.indexOf('is-empty') !== -1);
  }

  function applyEmptySections(sections) {
    if (!sectionsLookEmpty(sections)) return false;
    if (window.cartDrawerCustom && typeof window.cartDrawerCustom.applySections === 'function') {
      window.cartDrawerCustom.applySections(sections);
      return true;
    }
    return false;
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function parseJson(res, label) {
    if (!res.ok) throw new Error(label + ' ' + res.status);
    return res.json();
  }

  function getCart() {
    return liveFetch(cartRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      return parseJson(res, 'cart.js');
    });
  }

  function postClear() {
    if (!isGumClearPage()) {
      return Promise.reject(new Error('skip clear: data-ig-hide-chrome missing'));
    }
    return liveFetch(cartRoot() + 'cart/clear.js', {
      method: 'POST',
      keepalive: !isWebKit(),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: '{}',
    }).then(function (res) {
      return parseJson(res, 'cart/clear.js');
    });
  }

  function postStripDiscountCodes() {
    return liveFetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      keepalive: !isWebKit(),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '', sections: sectionPayload() }),
    }).then(function (res) {
      return parseJson(res, 'cart/update.js discount');
    }).catch(function () {
      return null;
    });
  }

  function forgetLaborDiscount() {
    if (window.laborCtaDiscount && typeof window.laborCtaDiscount.clear === 'function') {
      window.laborCtaDiscount.clear();
    }
  }

  function postUpdateZero(items) {
    var updates = {};
    for (var i = 0; i < items.length; i++) {
      updates[items[i].key] = 0;
    }
    return liveFetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      keepalive: !isWebKit(),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sectionPayload() }),
    }).then(function (res) {
      return parseJson(res, 'cart/update.js');
    });
  }

  function postChangeZero(item) {
    return liveFetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      keepalive: !isWebKit(),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 }),
    }).then(function (res) {
      return parseJson(res, 'cart/change.js');
    });
  }

  function cartHasItems(cart) {
    return !!(cart && cart.items && cart.items.length);
  }

  function zeroEachLine(items) {
    return items.reduce(function (p, item) {
      return p.then(function () {
        return postChangeZero(item);
      });
    }, Promise.resolve());
  }

  function attachSections(cart, data) {
    if (data && data.sections) cart.sections = data.sections;
    return cart;
  }

  function emptyCartPass() {
    var latestSections = null;
    return postClear()
      .then(function (data) {
        if (data && data.sections) latestSections = data.sections;
        return getCart().then(function (cart) {
          return attachSections(cart, { sections: latestSections });
        });
      })
      .then(function (cart) {
        if (!cartHasItems(cart)) return cart;
        return postUpdateZero(cart.items).then(function (data) {
          if (data && data.sections) latestSections = data.sections;
          return getCart().then(function (next) {
            return attachSections(next, { sections: latestSections });
          });
        });
      })
      .then(function (cart) {
        if (!cartHasItems(cart)) return cart;
        return zeroEachLine(cart.items).then(function () {
          return getCart().then(function (next) {
            return attachSections(next, { sections: latestSections });
          });
        });
      });
  }

  function emptyCartUntilGone(pass) {
    pass = pass || 0;
    return emptyCartPass().then(function (cart) {
      if (!cartHasItems(cart)) return cart;
      if (pass + 1 >= MAX_PASSES) return cart;
      return delay(RETRY_DELAYS_MS[pass + 1] || 500).then(function () {
        return emptyCartUntilGone(pass + 1);
      });
    });
  }

  function fetchAndApplyEmptySections(preferred) {
    paintEmptyCartUi();
    if (applyEmptySections(preferred)) return Promise.resolve();

    var ids = SECTION_IDS;
    if (document.getElementById('main-cart-items')) ids += ',cart-items,cart-footer';
    return liveFetch(cartRoot() + '?sections=' + ids + '&cb=' + Date.now(), {
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
    })
      .then(function (res) {
        return parseJson(res, 'sections');
      })
      .then(function (sections) {
        applyEmptySections(sections);
      })
      .catch(function () {});
  }

  function clearCartOnBack(force) {
    if (!isGumClearPage()) return;
    // force retries (pageshow 400/1200ms) must run even if the first Safari
    // fetch is still hung after bfcache — the in-flight lock would otherwise
    // swallow every follow-up and leave the cart intact.
    if (!force && window.__cartClearOnBackInFlight) {
      if (Date.now() - (window.__cartClearOnBackStartedAt || 0) < 3500) return;
    }
    if (!force && !shouldClearNow()) return;
    window.__cartClearOnBackInFlight = true;
    window.__cartClearOnBackStartedAt = Date.now();
    beginClearLock();
    paintEmptyCartUi();

    emptyCartUntilGone(0)
      .then(function (cart) {
        if (cartHasItems(cart)) {
          throw new Error('cart still has ' + cart.items.length + ' items after clear');
        }
        clearBundleFlag();
        forgetLaborDiscount();
        return postStripDiscountCodes().then(function (data) {
          return fetchAndApplyEmptySections((data && data.sections) || (cart && cart.sections));
        });
      })
      .catch(function (err) {
        console.error('[cart-clear-on-back-navigation] cart clear failed', err);
        paintEmptyCartUi();
      })
      .then(function () {
        window.__cartClearOnBackInFlight = false;
        endClearLock();
      });
  }

  window.__larineEmptyCartAfterCheckout = function () {
    whenGumIgHideChrome(function () {
      clearCartOnBack(true);
    });
  };

  if (window.__larineClearCartOnBackPage && (hasBundleFlag() || isBackForwardNavigation())) {
    whenGumIgHideChrome(function () {
      beginClearLock();
      paintEmptyCartUi();
      setTimeout(function () {
        clearCartOnBack(true);
      }, 0);
    });
  }

  function scheduleClearOnBack() {
    if (window.__larineClearCartOnBackPage !== true) return;
    whenGumIgHideChrome(function () {
      beginClearLock();
      paintEmptyCartUi();
      var delays = isWebKit() ? [50, 400, 1200, 2500] : [0, 400, 1200];
      for (var i = 0; i < delays.length; i++) {
        setTimeout(function () {
          clearCartOnBack(true);
        }, delays[i]);
      }
    });
  }

  window.addEventListener('pageshow', function (e) {
    var persisted = !!(e && e.persisted);
    if (!hasBundleFlag() && !persisted && !isBackForwardNavigation()) return;
    scheduleClearOnBack();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    if (!hasBundleFlag()) return;
    scheduleClearOnBack();
  });
})();
